export enum CopyStyleStorage {
  draft_data = '@copy_style/draft_data',
  copied_data = '@copy_style/copied_data',
}
